export enum Actions {
    LOGIN_USER = 'LOGIN_USER',
    LOGGOUT_USER = 'LOGGOUT_USER',
    REGISTER_USER = 'REGISTER_USER',
    GET_USER = 'GET_USER',
    GENERATE_NEW_KEY = 'GENERATE_NEW_KEY',

    HANDLE_COPY_TEXT = 'HANDLE_COPY_TEXT',

    NEW_FEEDBACK = 'NEW_FEEDBACK',
    GET_ALL_FEEDBACKS = 'GET_ALL_FEEDBACKS',
    GET_FEEDBACKS = 'GET_FEEDBACKS',
    GET_SUMMARY_FEEDBACK = 'GET_SUMMARY_FEEDBACK',
    CHANGE_ACTIVE_FEEDBACK = 'CHANGE_ACTIVE_FEEDBACK',
}
